import type { Comparison } from '../performance.ts';

export const COMPARISONS = ['none', 'previous', 'last_year'] as const satisfies readonly Comparison[];
